const DEFAULT_WIKI_TITLE = '红色沙漠·Wiki'
const STRATEGY_TITLE = '红色沙漠·攻略'

export function getWikiRouteTitle(page?: string) {
  return page === 'strategy' ? STRATEGY_TITLE : DEFAULT_WIKI_TITLE
}
